export const CLEAR_SCREENS = '@screen/CLEAR_SCREENS';
export const CLEAR_PARENT_SCREEN = '@screen/CLEAR_PARENT_SCREEN';
export const SCREEN_LOADED = '@screen/SCREEN_LOADED';
export const PARENT_SCREEN_LOADED = '@screen/PARENT_SCREEN_LOADED';